(function(){
  try {
    var p = window.location.pathname || "";
    if (p.indexOf("news-archive-") === -1) return;
    var parts = p.split("/").filter(Boolean);
    var handle = (parts[0] === "blogs" && parts.length >= 3) ? parts[2] : "";
    var dest = handle ? ("/blogs/8hp-guides/" + handle) : "/blogs/8hp-guides";
    window.location.replace(dest + window.location.search + window.location.hash);
  } catch (e) {}
})();
